import React, { useState, useContext } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";
import { updatePortalUser } from "../../api";
import { AuthContext } from "../../auth-context";
import Icon from "@material-ui/core/Icon";
import { useHistory } from "react-router-dom";

const Page = styled.div`
  background: #eff0f1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;

const Text = styled.div`
  font-family: "DM Sans", sans-serif;
  max-height: 600px;
  max-width: 800px;
  overflow-y: scroll;
  h5 {
    font-size: 1rem;
    font-weight: bold;
    margin-bottom: 12px;
  }
  p {
    margin-bottom: 12px;
  }
  
  .indent-1 {
    margin-left: 24px;

    span {
      margin-right: 24px
    }
  }

  .indent-2 {
    margin-left: 48px;

    span {
      margin-right: 24px
    }
  }
`;

const CheckContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 42px;
  p {
    margin-left: 18px;
  }
`;

const Button = styled.button`
  background: ${(props) =>
    props.alternateColor ? "none" : "linear-gradient(#00ee46, #0e9e38)"};
  border: ${(props) => (props.alternateColor ? "2px solid #07c43f" : "none")};
  border-radius: 100px;
  color: ${(props) => (props.alternateColor ? "#07c43f" : "#FFF")};
  cursor: pointer;
  font-family: DM Sans, sans-serif;
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0px;
  height: 56px;
  padding: 15px 36px;
  margin-top: 42px;
  text-transform: none;
  white-space: nowrap;
  opacity: ${(props) => (props.disabled ? "0.5" : "1")};

  @media (max-width: 900px) {
    font-size: 0.9rem;
    font-weight: 400;
    height: unset;
    white-space: unset;
    padding: 8px 16px;
  }
`;

const Login = () => {
  const { user, updateUser } = useContext(AuthContext);
  const [agree, setAgree] = useState(0);
  let history = useHistory();

  const handleClick = (e) => {
    if (agree === 1) {
      updatePortalUser(user.id, {
        agree_to_terms: agree,
      })
        .then(() => {
          let newUser = Object.assign({}, user)
          newUser['agree_to_terms'] = agree
          updateUser(newUser)
          history.push('/dashboard/overview')
        })
        .catch((err) => {
          console.log("error: ", err);
        });
    }
  };

  return (
    <Page>
      <Text>
        <p style={{textAlign: 'center',  marginBottom: 0}}><b>TERMS OF USE AGREEMENT</b></p>
        <p style={{textAlign: 'center'}}><b>AVATAR NUTRITION</b></p>
        <p style={{textAlign: 'center'}}><b>IMPORTANT: READ CAREFULLY</b></p>
        <p>
          This Terms of Use Agreement (the “<b>Agreement</b>") is a legal agreement
          between <b>“You”</b> and Avatar Nutrition, LLC (<b>“Avatar Nutrition,”</b> <b>“We”</b> or
          <b>“Us”</b>) for the Service (as such term is defined below).
        </p>
        <p>
          The Service is provided by Avatar Nutrition for the purpose of
          creating a platform for review of health, diet, and fitness
          information. Through the Service, You may input information that is
          used as indicators of health and fitness and the Service may provide
          You with information concerning health and fitness. The Service may
          also provide information and links related to other Avatar Nutrition
          products and services, and third party products and services.
        </p>
        <p>
          <b>
            IF YOU DO NOT ACCEPT ALL OF THE TERMS AND CONDITIONS OF THIS
            AGREEMENT, AVATAR NUTRITION IS UNWILLING TO LICENSE THE SERVICE TO
            YOU, NO LICENSE IS GRANTED AND YOU ARE NOT AUTHORIZED TO USE THE
            SERVICE.
          </b>
        </p>
        <p>
          <b>
            By accessing the Service’s interactive elements, creating a user
            account, or otherwise using the Service, You represent to Us that you
            are at least 18 years old and You agree to be bound by the terms of
            this Agreement along with the Avatar Nutrition Privacy Policy.
          </b>
        </p>
        <p>
          This Agreement governs your use of the Service only. Any other
          contractual agreements between You and Avatar Nutrition remain in
          effect.
        </p>
        <h5>1. Software Delivery and Acceptance</h5>
        <p>
          Subject to Your agreement to be bound by all terms and conditions of
          this Agreement, Avatar Nutrition authorizes You to use and access (i)
          Avatar Nutrition’s proprietary software, which includes compiled
          software code, images, music, media, templates, data, a user
          interface, any documentation accompanying the program, and any updates
          or supplements of such software and documentation (collectively, the
          <b>“App”</b>); and (ii) Avatar Nutrition’s proprietary software and related
          media accessible at www.avatarnutrition.com, including all related
          subdomains (the <b>“Website”</b>). The App and Website are referred to herein
          collectively as the <b>“Service”</b>. The Service is deemed accepted by You
          when the App is initially downloaded by You, or when you access the
          Website.
        </p>
        <h5>2. License Terms and Conditions</h5>
        <p>
          Subject to all terms and conditions of this Agreement, Avatar
          Nutrition hereby grants You a nonexclusive, personal,
          non-transferable, non-assignable, limited license to use and access
          the Service in accordance with this Agreement and any and all
          agreements and documents executed by You or delivered by Avatar
          Nutrition. The Service is licensed to you, not sold, and Avatar
          Nutrition reserves the right to revoke such license at any time and
          disable your ability to use the Service for any reason or for no
          reason.
        </p>
        <p>
          <b>2.1 <u>Avatar Nutrition Privacy Policy</u>.</b> The Avatar Nutrition Privacy Policy
          located at <a href='https://www.avatarnutrition.com/privacy'>https://www.avatarnutrition.com/privacy</a> is incorporated
          herein by reference (“Privacy Policy”). The Privacy Policy provides
          information about your privacy rights and explains how Avatar
          Nutrition protects your personal information.
        </p>
        <h5>3. Proprietary Rights</h5>
        <p>
          The Service is protected by copyright laws, international copyright
          treaties, and other intellectual property laws and treaties. All
          rights in the Service not expressly licensed under this Agreement are
          reserved to Avatar Nutrition. You shall not reproduce, retransmit,
          disseminate, sell, publish, broadcast, circulate, rent, lease,
          sublicense, assign, or otherwise transfer any portion of the Service
          except as expressly authorized in this Agreement. No right to use any
          trademark or trade name of Avatar Nutrition is granted to You
          hereunder other than the right to display the Avatar Nutrition marks
          that are placed on the Service and any Avatar Nutrition communications
          when they are rendered in the Service, in which case such marks may
          not be altered or removed by You without written approval by Avatar
          Nutrition.
        </p>
        <h5>4. Service Usage</h5>
        <p><b>4.1</b> <u>Overview & Fees.</u></p>
        <p>
          Accessing the Service and creating an account are free. Through the
          Service you may post content, review content, and communicate with
          other users. Some content offered by Avatar Nutrition and by other
          users of the Service requires payment by You to access. If You access
          content that does require payment, You agree to immediately pay to
          Avatar Nutrition the requested amount, and that You access such
          content at Your own risk of satisfaction in the content. Payments made
          by You to Us are not refundable for any reason. We do not provide
          credit, refunds, or prorated billing for subscriptions that are
          cancelled mid-month. In such a circumstance, You will continue having
          access to the Services until the end of the then-present billing
          cycle. We reserve the right to offer refunds, discounts, or other
          considerations in select circumstances at Our sole discretion. Please
          note that each circumstance is unique and election to make such an
          offer in one instance does not create the obligation to do so in
          another.
        </p>
        <p><b>4.2</b> <u>No Health-Related Advice</u>.</p>
        <p>
          The Service is provided as a platform to allow users to deliver and
          review content related to health and fitness. Health and
          fitness-related decisions may involve risk and Avatar Nutrition does
          not endorse or recommend any particular content provided through the
          Service. YOU REPRESENT AND WARRANT THAT YOU ASSUME ALL RISK AND
          RESPONSIBILITY ASSOCIATED WITH YOUR ACTIVITIES ARISING OUT OF YOUR USE
          OF THE SERVICE AND HEREBY RELEASE AND DISCHARGE US FROM AND WAIVE ANY
          AND ALL CAUSES OF ACTION AGAINST OTHER PARTIES, INCLUDING US, ARISING
          OUT OF THESE ACTIVITIES. THIS RELEASE AND WAIVER CONTEMPLATES BUT IS
          NOT LIMITED TO LIABILITY RELATED TO DEATH, DISABILITY, PERSONAL
          INJURY, AND/OR ILLNESS, WHICH MAY HEREAFTER ACCRUE AND/OR OCCUR FROM
          YOU USING OR IMPLEMENTING ANY CONTENT OR INFORMATION CONTAINED IN THE
          SERVICES. This release and waiver shall be construed as broadly as
          possible to provide a release and waiver to the maximum extent
          permissible by law.
        </p>
        <p>
          When using the Service, you may receive information relating to health
          and fitness techniques, strategies, and other related information. You
          should not rely on any health and fitness-related information you
          receive from other users and you acknowledge that you should consult
          with such medical professionals you deem appropriate before
          participating in any activities recommended, disseminated, or
          otherwise related to the Service.
        </p>
        <p>
          Therefore, You further represent and warrant that You have met with,
          been examined by, and consulted with a medical professional prior to
          implementing any or all of the content or information presented in the
          Service and that you shall not implement any or all of the content or
          information presented in the Service absent approval by Your medical
          professional. You further represent and warrant that you shall not
          share content or information presented by the Service with any
          third-party except a medical professional acting in the course of that
          medical professional’s duty.
        </p>
        <p>
          If You are a medical professional who is training or otherwise
          advising users of the Service, or interacting with the Service on
          behalf of other users of the Service, YOU REPRESENT THAT YOU ASSUME
          ALL RISK AND RESPONSIBILITY ASSOCIATED WITH OR ARISING OUT OF YOUR
          INTERACTION WITH YOUR CLIENTS’ USE OF THE SERVICE AND YOU HEREBY
          RELEASE AND DISCHARGE US FROM AND WAIVE ANY AND ALL CAUSE OF ACTION
          AGAINST OTHER PARTIES, INCLUDING US, ARISING OUT OF THESE ACTIVITIES.
          THIS RELEASE AND WAIVER CONTEMPLATES BUT IS NOT LIMITED TO LIABILITY
          RELATED TO DEATH, DISABILITY, PERSONAL INJURY, AND/OR ILLNESS, WHICH
          MAY HEREAFTER ACCRUE AND/OR OCCUR FROM YOUR CLIENTS USING OR
          IMPLEMENTING ANY CONTENT OR INFORMATION CONTAINED IN THE SERVICES.
          This release and waiver shall be construed as broadly as possible to
          provide a release and waiver to the maximum extent permissible by law.
        </p>
        <h5>5. User Content</h5>
        <p>
          Avatar Nutrition may allow You to upload or post audio, video, images,
          text or other content through the Service (<b>“User Content”</b>). All
          feedback and other User Content you provide to Avatar Nutrition,
          whether via the Service or otherwise, shall be deemed to be
          non-confidential and You hereby waive any proprietary or confidential
          rights related to the User Content. Subject to the Privacy Policy and
          applicable law, Avatar Nutrition shall be free to use such information
          on an unrestricted basis, and You grant Avatar Nutrition all
          appropriate rights to do so in perpetuity.
        </p>
        <p>
          Avatar Nutrition does not have the obligation to pre-screen any User
          Content. However, Avatar Nutrition reserves the right to remove or
          edit any User Content at any time and without notice to You. When you
          use the Service, you agree not to upload, post, modify, distribute,
          email, transmit, or otherwise make available any User Content that:
        </p>
        <p className="indent-1">
          <span>A.</span> is unlawful, libelous, defamatory, obscene, pornographic, indecent,
          lewd, harassing, threatening, harmful, invasive of privacy or
          publicity rights, abusive, inflammatory or otherwise injurious to
          third parties;
        </p>
        <p className="indent-1">
          <span>B.</span> is protected by any patent, trademark, trade secret, copyright or
          other intellectual or proprietary right, unless you own such rights or
          have received all necessary consent;
        </p>
        <p className="indent-1">
          <span>C.</span> impersonates any person or entity or otherwise misrepresents your
          affiliation with a person or entity, or interfere with someone else’s
          use of the Site;
        </p>
        <p className="indent-1">
          <span>D.</span> falsely provides a review for a product or service that you have not
          purchased or used, or misrepresents your experiences relating to any
          products or services;
        </p>
        <p className="indent-1">
          <span>E.</span> constitutes a charity request, petition for signatures, chain letter,
          letter or information relating to one or more pyramid schemes,
          advertising or solicitation for funds, political campaigning, mass
          mailing, any form of unsolicited commercial email or "spam," or an
          offering or dissemination of fraudulent goods, services, schemes or
          promotions;
        </p>
        <p className="indent-1">
          <span>F.</span> is sent via unsolicited email, if such email could reasonably be
          expected to provoke complaints from its recipients;
        </p>
        <p className="indent-1">
          <span>G.</span> is harmful, including without limitation, viruses, Trojan horses,
          worms, time bombs, zombies, cancelbots, or any other computer
          programming routines that may damage, interfere with, surreptitiously
          intercept or expropriate any system, program, data or personal
          information; and/or
        </p>
        <p className="indent-1">
          <span>H.</span> violates any applicable local, state, national or international law.
          (collectively <b>“Prohibited User Content”</b>).
        </p>
        <h5>6. Digital Millennium Copyright Act – Notice & Takedown</h5>
        <p>
          If you are a copyright owner and believe that any User Content or any
          content provided by the Services infringes upon your copyright rights,
          you may submit a notification to Avatar Nutrition’s Designated Agent
          at: 
        </p>
        <p>
          Avatar Nutrition <br />
          PO Box 162198 <br />
          Austin TX 78716-2198 <br />
        </p>
        <p>
          Pursuant to the Digital Millennium Copyright Act 17
          U.S.C. Sec. 512(c)(2), such notification must include:
        </p>
        <p>
          A description of the copyrighted work that you claim has been
          infringed; a description of where the alleged infringing material is
          located; a statement by you that you have a good faith belief that the
          disputed use is not authorized by the copyright owner, its agent, or
          the law; an electronic or physical signature of the person authorized
          to act on behalf of the owner of the copyright interest; Your contact
          information (email and telephone number); and a statement by you, made
          under penalty of perjury, that the above information in your notice is
          accurate and that you are the copyright owner or are authorized to act
          on the copyright owner's behalf.
        </p>
        <h5>7. Representations and Warranties</h5>
        <p>
          You represent and warrant the following during your download,
          installation, and/or use of the Service:
        </p>
        <p className="indent-1">
          <span>A.</span> You are not located in a country that is subject to a U.S. Government
          embargo, or has been designated by the U.S. Government as a “terrorist
          supporting” country;
        </p>
        <p className="indent-1">
          <span>B.</span> You are not listed on any U.S. government list of prohibited or
          restricted parties;
        </p>
        <p className="indent-1">
          <span>C.</span> You possess all necessary rights to distribute, post, or other
          disseminate any User Content you disseminate using the Service;
        </p>
        {/* <p>
          D. You are a citizen of the United States and residing in the United
          States;
        </p> */}
        <p className="indent-1">
          <span>D.</span> You are at least 18 years of age or older if the age of majority is
          more than 18 in your relevant jurisdiction; and
        </p>
        <p className="indent-1"><span>E.</span> You will not post any Prohibited User Content.</p>
        <h5>8. Third Party Content</h5>
        <p>
          The Service may display, include, make available or link to content,
          data, information, applications, websites or materials from third
          parties (“Third-Party Content”). Avatar Nutrition is not responsible
          for the content, accuracy, completeness, timeliness, validity,
          copyright compliance, legality, decency, quality, efficiency,
          advertising, terms of use, privacy policy, practices, software code or
          any other aspect of the Third-Party Content. You are encouraged to
          read the terms of use and privacy policy of any third-party websites
          to which you connect when using the Service. Avatar Nutrition
          disclaims all liability arising from or relating to the Third-Party
          Content.
        </p>
        <p>
          Third-Party Content may contain proprietary content, information and
          material that is protected by applicable intellectual property and
          other laws, including but not limited to copyright and trademark laws.
          You may not use such proprietary content, information or materials in
          any way whatsoever except to use the Service for its intended
          purposes.
        </p>
        <h5>9. Internet Access</h5>
        <p>
          Use of the Service requires an internet connection and may result in
          charges from your cellular service provider. Avatar Nutrition is not
          responsible for any such charges. Avatar Nutrition is also not liable
          for any disruption, failure or malfunction of the Internet or other
          service providers or for any other situation or event that is out of
          Avatar Nutrition’s direct control. AVATAR NUTRITION IS NOT RESPONSIBLE
          FOR ANY ACTS OR OMISSIONS OF YOUR CELLULAR COMMUNICATION OR INTERNET
          SERVICE PROVIDERS, OR UNAVAILABILITY OR ERRORS ASSOCIATED WITH THEIR
          SYSTEMS OR SERVICES.
        </p>
        <h5>10. Restrictions on Use</h5>
        <p>
          Unless and to the extent specifically provided otherwise in writing by
          Avatar Nutrition, you may not:
        </p>
        <p className="indent-1"><span>A.</span> separate any individual component of the Service for use;</p>
        <p className="indent-1">
          <span>B.</span> incorporate any portion of the Service into other software or compile
          any portion of it in combination with other software;
        </p>
        <p className="indent-1">
          <span>C.</span> use the Service, or any portion of Service, with any other service or
          over a network;
        </p>
        <p className="indent-1">
          <span>D.</span> sell, rent, lease, lend, loan, distribute, assign or sublicense the
          Service or otherwise transfer any rights to it in whole or in part;
        </p>
        <p className="indent-1">
          <span>E.</span> modify, reverse engineer, decompile, remove any proprietary notices or
          disassemble the Service in whole or in part, or create any derivative
          works from or of the Service, or encourage, assist or authorize any
          other person to do any of these things; or
        </p>
        <p className="indent-1">
          <span>F.</span> make copies of or distribute the Service or electronically transfer it
          or any portion of it from one computer to another or over a network.
        </p>
        <p>
          We may discontinue some or all of the functionality of the Service at
          any time. We may also terminate your right to use the Service at any
          time, and in such event we may modify it to make it inoperable. You
          agree to abide by all laws and regulations in effect regarding your
          use of the Service, including without limitation, all driving laws and
          laws relating to copyright-protected content. You may not authorize or
          assist any third party to do any of the things prohibited in this
          paragraph.
        </p>
        <h5> 11. Updates</h5>
        <p>
          Avatar Nutrition may from time to time, in its sole discretion, make
          updates, modifications, supplements or new versions of the Service or
          portions thereof available to You under this Agreement for the purpose
          of, among other things, distributing bug fixes, patches and feature
          improvements. Avatar Nutrition disclaims any and all liability
          relating to Your failure to install any updates to the Service. Avatar
          Nutrition does not have any obligation to provide any bug fixes,
          modifications, updates, or technical or end user support for the
          Service.
        </p>
        <h5> 12. Collection and Use of Data</h5>
        <p>
          You acknowledge that the Service automatically collects information,
          data and statistics relating to your use of the Service, and compiles
          such information, data and statistics. Subject to the terms of the
          Privacy Policy, Avatar Nutrition reserves the right to use such
          information, data and statistics in the course of Avatar Nutrition’s
          business, and you hereby agree to Avatar Nutrition’s use. Unless
          specifically agreed in writing by Avatar Nutrition, Avatar Nutrition
          is not responsible for, and hereby disclaims all warranties relating
          to, the storage of any data for use with the Service.
        </p>
        <h5> 13. Login Credentials</h5>
        <p>
          You shall not share Your user account information with others or allow
          third parties to use Your login credentials to the Service at any time
          or for any reason unless otherwise allowed in writing by Avatar
          Nutrition. You warrant, and Avatar Nutrition may assume and rely on
          the assumption, that any and all activity and use of the Service under
          Your user account is done by You. You are solely responsible for
          maintaining the security of, for example, your username, password, and
          all other user account information, and You agree that Avatar
          Nutrition will not be liable for any loss or damages resulting from
          use of your account by others.
        </p>
        <h5> 14. Indemnification</h5>
        <p>
          <b>
            You shall defend, indemnify, and hold harmless, Avatar Nutrition and
            its owners, officers, members, managers, directors, shareholders,
            subsidiaries, joint-ventures, partners, employees, agents, licensors,
            and licensees from and against any and all claims, actions, suits,
            proceedings, demands, losses, liabilities, damages, judgments,
            settlements, penalties, costs, and expenses (including without
            limitation all reasonable attorneys’ fees), known and unknown, arising
            out of (i) Your use of the Service; (ii) any dispute between You and
            any other user or users; (iii) Your use, creation or posting of
            Prohibited User Content; (iv) Your violation or breach of this
            Agreement, or (v) the infringement by You, or any other user of Your
            username or account, of any intellectual property or right of any
            person or entity.
          </b>
        </p>
        <h5> 15. Disclaimers; Limitations of Liability</h5>
        <p>
          AVATAR NUTRITION DOES NOT PROMISE THAT THE SERVICE OR ANY
          FUNCTIONALITY THEREOF WILL BE ERROR-FREE OR UNINTERRRUPTED OR THAT
          YOUR USE OF THE SERVICE WILL PROVIDE SPECIFIC RESULTS. THE SERVICE IS
          PROVIDED BY AVATAR NUTRITION “AS-IS” AND “AS-AVAILABLE” WITHOUT ANY
          OTHER WARRANTY OR REPRESENTATION OF ANY KIND. AVATAR NUTRITION CANNOT
          ENSURE THAT THE SERVICE OR ANY FILES OR OTHER DATA YOU DOWNLOAD OR
          UPLOAD IN RELATION TO THE SERVICE WILL BE FREE OF VIRUSES OR
          CONTAMINATION OR DESTRUCTIVE FEATURES. YOUR USE OF THE SERVICE, AND
          THE RESULTS AND PERFORMANCE ACHIEVED USING THE SERVICE, IS AT YOUR OWN
          RISK. AVATAR NUTRITION DISCLAIMS ALL OTHER WARRANTIES, EXPRESS,
          IMPLIED OR STATUTORY, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES
          OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
          NON-INFRINGEMENT, AND ANY WARRANTIES ARISING FROM COURSE OF DEALING,
          USAGE OR TRADE PRACTICE WITH RESPECT TO THE SERVICE. THE ENTIRE RISK
          AS TO THE QUALITY, OR ARISING OUT OF THE USE OR PERFORMANCE OF THE
          SERVICE REMAINS WITH YOU.
        </p>
        <p>
          TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT SHALL
          AVATAR NUTRITION BE LIABLE FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL,
          PUNITIVE, INCIDENTAL OR SPECIAL DAMAGES WHATSOEVER (INCLUDING WITHOUT
          LIMITATION DAMAGES FOR LOSS OF PROFITS, BUSINESS INTERRUPTION, LOSS OF
          BUSINESS INFORMATION, AND THE LIKE) ARISING OUT OF THE USE OF OR
          INABILITY TO USE THE SERVICE, ANY PROVISION OF OR FAILURE TO PROVIDE
          SUPPORT, OR OTHERWISE UNDER OR IN CONNECTION WITH THIS AGREEMENT, EVEN
          IN THE EVENT OF THE FAULT, TORT (INCLUDING NEGLIGENCE), STRICT
          LIABILITY, BREACH OF CONTRACT OR BREACH OF WARRANTY OF AVATAR
          NUTRITION, AND EVEN IF AVATAR NUTRITION HAS BEEN ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES.
        </p>
        <p>
          IF, NOTWITHSTANDING THE OTHER PROVISIONS OF THIS AGREEMENT, AVATAR
          NUTRITION IS FOUND TO BE LIABLE TO YOU FOR ANY DAMAGE OR LOSS WHICH
          ARISES OUT OF OR IS IN ANY WAY CONNECTED WITH YOUR USE OF THE SERVICE,
          AVATAR NUTRITION’S LIABILITY SHALL IN NO EVENT EXCEED THE TOTAL OF ANY
          SUBSCRIPTION OR SIMILAR FEES WITH RESPECT TO THE SERVICE PAID IN THE
          SIX MONTHS PRIOR TO THE DATE OF THE INITIAL CLAIM MADE AGAINST AVATAR
          NUTRITION. SOME JURISDICTIONS DO NOT ALLOW LIMITATIONS OF LIABILITY,
          SO THE FOREGOING LIMITATION MAY NOT APPLY TO YOU.
        </p>
        <h5> 16. Termination</h5>
        <p>
          Without limiting its rights and remedies, if You fail to comply with
          the terms and conditions of this Agreement, Avatar Nutrition may, in
          its sole discretion, terminate this Agreement upon any such failure.
          Upon termination of this Agreement, You must promptly cease all use of
          the Service and discontinue exercising all license rights granted by
          this Agreement. Sections 3 through 21 of this Agreement will survive
          any termination of this Agreement.
        </p>
        <h5> 17. Dispute Resolution; Choice of Law</h5>
        <p className="indent-1">
          <span>A.</span> This Agreement shall be construed and controlled by the laws of the
          State of Texas without reference to its choice of law provisions, and
          You consent to jurisdiction and venue in the courts sitting in Travis
          County, Texas. You waive and covenant not to assert all defenses of
          lack of personal jurisdiction and forum non conveniens. You further
          hereby acknowledge and consent that any controversy or claim arising
          out of or relating to these Terms & Conditions, or anything in any way
          related to the Services, shall be resolved through binding arbitration
          pursuant to the commercial arbitration rules of the American
          Arbitration Association, as follows:
        </p>
        <p className="indent-2">
          <span>i.</span> The parties must first attend non-binding mediation (except as set
          forth below). Mediation shall be paid by the party that files for same
          and mediation shall take place in Austin, Texas, and Texas law shall
          govern.
        </p>
        <p className="indent-2">
          <span>ii.</span> In the event that non-binding mediation is unsuccessful, then the
          dispute will be resolved through binding arbitration. Arbitration
          shall take place in Austin, Texas, and Texas law shall govern.
        </p>
        <h5> 18. Export Law Compliance</h5>
        <p>
          You acknowledge that the Service is of U.S. origin. You agree to
          comply with all applicable international and national laws that apply
          to the Service, including all applicable U.S. export-control laws and
          regulations, as well as any end-user, end-use and destination
          restrictions issued by U.S. and other governments.
        </p>
        <h5> 19. Other Agreements</h5>
        <p>
          This Agreement constitutes an individual consent by You to be bound by
          the terms of this Agreement and is the entire agreement between You
          and Avatar Nutrition with respect to Your use of the Service, and any
          and all other written or oral agreements or understandings previously
          existing between You and Avatar Nutrition with respect to such use are
          hereby superseded and cancelled. This Agreement is not intended to
          supersede or replace any other agreements entered into with Avatar
          Nutrition by You or Your company. To the extent there are any
          conflicts or inconsistencies between this Agreement and any other
          agreement, policy or documentation, the following order of precedence
          will apply for resolving such conflicts or inconsistences: (i) this
          Agreement shall control; and then (ii) any other agreements, policies,
          or documentation.
        </p>
        <h5> 20. Void Where Prohibited</h5>
        <p>
          Although the Service is accessible worldwide, not all features,
          products or services discussed, referenced, provided or offered
          through or on the Service are available to all persons or in all
          geographic locations, or appropriate or available for use outside the
          United States. Avatar Nutrition reserves the right to limit, in its
          sole discretion, the provision and quantity of any feature, product or
          service to any person or geographic area. Any offer for any feature,
          product or service made on the Service is void where prohibited. If
          you choose to access the Service from outside the United States, you
          do so on your own initiative and you are solely responsible for
          complying with applicable local laws.
        </p>
        <h5> 21. Miscellaneous</h5>
        <p>
          If any of the provisions of this Agreement are held by a court or
          other tribunal of competent jurisdiction to be void or unenforceable,
          such provisions shall be limited or eliminated to the minimum extent
          necessary and replaced with a valid provision that best embodies the
          intent of this Agreement, so that this Agreement shall remain in full
          force and effect. Avatar Nutrition’ failure to insist on or enforce
          strict performance of this Agreement shall not be construed as a
          waiver by Avatar Nutrition of any provision or any right it has to
          enforce this Agreement, nor shall any course of conduct between Avatar
          Nutrition and you or any other party be deemed to modify any provision
          of this Agreement. This Agreement shall not be interpreted or
          construed to confer any rights or remedies on any third parties.
        </p>
        <p>
          You acknowledge and agree that you have had an opportunity to review
          these Terms with independent legal counsel. You understand you are
          under no obligation to use the Services or otherwise engage in any
          activity that would act as an acceptance of these Terms, but you
          voluntarily do so.
        </p>
      </Text>

      <CheckContainer>
        <Icon onClick={() => setAgree(1 - agree)}>
          {agree ? "check_box" : "check_box_outline_blank"}
        </Icon>
        <p>I agree to Terms of Service</p>
      </CheckContainer>

      <Button disabled={!agree} onClick={handleClick}>
        Continue
      </Button>
    </Page>
  );
};

export default withRouter(Login);
